export const DEFAULT_MAX_VALUE = 1000
export const DEFAULT_MIN_VALUE = 0
export const DEFAULT_MAX_LENGTH = 5
export const INPUT_MASK_TOKEN = /[0-9-]/
export const TEST_ID = 'base-counter-input'
